// 문의 답변 상태 표시 문구. 목록·상세가 함께 쓴다.
export const INQUIRY_STATUS_LABELS = { pending: '답변 대기', answered: '답변 완료' };
